import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import { HorizontalCardDescription } from '@velasca/ui/horizontal-card-description'
import { HorizontalCardTitle } from '@velasca/ui/horizontal-card-title'
import { Separator } from '@velasca/ui/separator'
import {
  Controls,
  Details,
  Header,
  ImageWrapper,
  ItemQuantity,
  LoadingImage,
  ProductDetails,
} from './LineItem.styles'

const StyledSkeleton = styled(Skeleton)`
  font-size: inherit;

  span {
    font-size: inherit;
  }
`

export const LineItemSkeleton = (): JSX.Element => {
  return (
    <>
      <Header>
        <ImageWrapper>
          <LoadingImage />
        </ImageWrapper>
        <Details>
          <div>
            <HorizontalCardTitle>
              <StyledSkeleton width="11rem" />
            </HorizontalCardTitle>
            <HorizontalCardDescription>
              <StyledSkeleton width="8rem" />
            </HorizontalCardDescription>
            <ProductDetails>
              <HorizontalCardDescription>
                <StyledSkeleton width="6rem" />
              </HorizontalCardDescription>
              <HorizontalCardDescription>
                <StyledSkeleton width="3rem" />
              </HorizontalCardDescription>
              <HorizontalCardDescription>
                <StyledSkeleton width="13rem" />
              </HorizontalCardDescription>
            </ProductDetails>
          </div>
          <StyledSkeleton width="6rem" />
        </Details>
      </Header>
      <Controls>
        <ItemQuantity
          css={`
            padding: 1.1rem 0;
          `}
        >
          <Skeleton circle inline width="2.3rem" height="2.3rem" />

          <StyledSkeleton
            width="2rem"
            height="2.3rem"
            css={`
              margin: 0 1rem;
            `}
          />
          <Skeleton circle inline width="2.3rem" height="2.3rem" />
        </ItemQuantity>
        <StyledSkeleton width="4rem" />
      </Controls>
      <Separator />
    </>
  )
}
